import { apiHelper } from '@/utils'

const API_URL = process.env.VUE_APP_API_BASE_URL + '/v1'

/**
 * Appointments the brand's bot took.
 *
 * Scoped to the brand being worked in — the server reads it from the tenant
 * header and refuses "All brands", because appointments belong to one brand
 * and the alternative is showing somebody another client's clinic schedule.
 *
 * Moving one goes through `reschedule`, never `update`: a booking exists both
 * here and as a calendar slot, and only the bot keeps the two in step.
 */
export const appointmentService = { list, get, update, reschedule, cancel, claim }

export async function list(params = {}) {
  return apiHelper(API_URL).get('/appointments', { params })
}

export async function get(apptRef) {
  return apiHelper(API_URL).get(`/appointments/${encodeURIComponent(apptRef)}`)
}

/** Confirm, complete, or correct where it happens. Never the time. */
export async function update(apptRef, payload) {
  return apiHelper(API_URL).patch(`/appointments/${encodeURIComponent(apptRef)}`, payload)
}

/**
 * Take the job.
 *
 * Who took it is read from the token on the server, never sent from here —
 * the whole feature rests on that name being true. The claimer goes on the
 * Cal.com booking as a guest, so the invite arrives in their own mailbox.
 */
export async function claim(apptRef) {
  return apiHelper(API_URL).post(`/appointments/${encodeURIComponent(apptRef)}/claim`, {})
}

export async function reschedule(apptRef, payload) {
  return apiHelper(API_URL).post(`/appointments/${encodeURIComponent(apptRef)}/reschedule`, payload)
}

export async function cancel(apptRef, reason) {
  return apiHelper(API_URL).post(`/appointments/${encodeURIComponent(apptRef)}/cancel`, { reason })
}
